import { vpp, VPP_API } from '../api/vpp';
import * as types from './types';

const setStickered = (payload) => ({ type: types.SET_STICKERED, payload });

export const getStickered = (search) => (dispatch) =>
  vpp.get(VPP_API.stickered, search ? { params: search } : null).then(({ data }) => {
    dispatch(setStickered(data));
  });
